export default function aos() {
    if (window.innerWidth > 1200) {
        AOS.init();
        return;
    }

    AOS.init({ disable: true, });
}